import { useContext } from 'react';
import { ConfirmContext } from './provider';

export const useConfirm = () => useContext(ConfirmContext);
